
export default {
  variants: {
    outline: {
      field: {
        fontSize: "14px",
        borderColor: "muted",
        _hover: {
          borderColor: "primary.light",
        },
      },
    },
    darkDefault: {
      field: {
        borderColor: "black",
        bg: "white",
        fontSize: ["sm", null, null, "md", null],
        _placeholder: { color: "text.dark" },
      },
    },
    lightBox: {
      field: {
        border: "1px solid",
        borderColor: "white",  
        bg: "white",
        borderRadius: "1px",  
        _placeholder: { color: "lightSearch" }, 
        fontSize: ["sm", "sm", "sm", "sm", null],
      },
    },
    greyInput: {
      field: {
        border: "1px solid",
        borderColor: "greyInput",  
        // bg: "white",
        borderRadius: "3px",  
        _placeholder: { color: "lightSearch" }, 
        _hover: {bg: "blueInputHover"},
        fontSize: ["sm"],
      },
    },
    primaryInput: {
      field: {
        mt: 1,
        border: "1px solid",
        _placeholder: { color: "text.lighter" },
        borderRadius:"md",
        borderColor: "primary.dark",
        
        fontSize: ["sm", null, null, "md", null],
      },
    },
  },
  defaultProps: {
    focusBorderColor: "primary.dark",
    errorBorderColor: "error",
  },
};